import { ChevronRight } from '@mui/icons-material';
import { Card, IconButton, Stack } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  title: string;
  width?: string;
  expandable?: boolean;
  isExpanded?: boolean;
  onExpand?: () => void;
  children: ReactNode;
}

export const ProductInformationCard = ({
  title,
  width = '100%',
  children,
  expandable,
  isExpanded,
  onExpand,
}: Props) => {
  return (
    <Card variant="outlined" sx={{ width: width, borderRadius: 0 }}>
      <Stack px={2} py={1} bgcolor="divider">
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
          {title}
          {expandable && (
            <IconButton onClick={onExpand} sx={{ zIndex: 1, p: 0 }}>
              <ChevronRight
                sx={{
                  transform: isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)',
                  transition: 'transform 0.2s ease-in-out',
                }}
              />
            </IconButton>
          )}
        </Stack>
      </Stack>
      {children}
    </Card>
  );
};
